 <!-- skeleton -->
 <ng-template #loadingSkeleton>
   <nz-skeleton class="bg-white dark:bg-white/10 rounded-6 p-[30px] pt-[15px]" [nzShape]="circle" [nzActive]="true"
     [nzParagraph]="{ rows: 5}"></nz-skeleton>
 </ng-template>
 <ng-template #loadingSkeletonheading>
   <nz-skeleton class="bg-white dark:bg-white/10 rounded-6 p-[30px] pt-[15px]" [nzShape]="circle" [nzActive]="true"
     [nzParagraph]="{ rows: 1}"></nz-skeleton>
 </ng-template>
 <!-- skeleton -->
 <div nz-row nzGutter="25" class="mt-[4px]" class="mt-[4px] mb-[34px]">
  <div nz-col nzMd="12" nzXs="24" class="flex items-center max-md:justify-center max-md:mb-[20px]">
    <div class="inline-flex items-center">
      <h1 class="text-dark dark:text-white/[.87] text-[20px] font-semibold mb-0">Projects</h1><span
        class="relative ltr:ml-3 rtl:mr-3 ltr:pl-[15px] rtl:pr-[15px] text-body dark:text-white/60 text-[15px] font-medium before:absolute before:top-0 ltr:before:left-0 rtl:before:right-0 before:w-[1px] before:h-6 before:bg-normal dark:before:bg-white/10">12
        Running Projects</span>
    </div>
  </div>
  <div nz-col nzMd="12" nzXs="24">
    <!-- New project added -->
    <div class="flex items-center justify-end max-md:justify-center">
     <button class="flex items-center px-[25px] text-sm text-white rounded-md font-semibold bg-primary border-primary h-11 gap-[6px]" nz-button (click)="showNewProject(newProjectContent)">
       <i nz-icon nzType="plus"></i>
       <span class="m-0">Create Projects</span>
     </button>
    </div>
    <ng-template #newProjectContent>
      <form nz-form nzLayout="vertical">
        <nz-form-item>
          <nz-form-control>
            <input class="h-[50px] border-normal dark:border-white/10 px-[20px] placeholder-shown:text-light-extra dark:placeholder-shown:text-white/60 rounded-[5px] dark:bg-white/10 dark:text-white/60" type="text" nz-input placeholder="Project Name" name="first">
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control>
            <nz-select class="min-w-[260px] capitalize [&>nz-select-top-control]:border-normal dark:[&>nz-select-top-control]:border-white/10 [&>nz-select-top-control]:bg-white [&>nz-select-top-control]:dark:bg-white/10 [&>nz-select-top-control]:shadow-none [&>nz-select-top-control]:text-dark [&>nz-select-top-control]:dark:text-white/60 [&>nz-select-top-control]:h-[50px] [&>nz-select-top-control]:flex [&>nz-select-top-control]:items-center [&>nz-select-top-control]:rounded-[5px] [&>nz-select-top-control]:px-[20px] [&>.ant-select-arrow]:text-theme-gray dark:[&>.ant-select-arrow]:text-white/60" ngModel="category2" name="first">
              <nz-option nzValue="category2" nzLabel="project category"></nz-option>
              <nz-option nzValue="rated" nzLabel="top rated"></nz-option>
              <nz-option nzValue="popular" nzLabel="popular"></nz-option>
              <nz-option nzValue="newest" nzLabel="newest"></nz-option>
              <nz-option nzValue="price" nzLabel="price"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control>
            <textarea class="h-[118px] border-normal dark:border-white/10 px-[20px] placeholder-shown:text-light-extra dark:placeholder-shown:text-white/60 rounded-[5px] py-[15px] dark:bg-white/10 dark:text-white/60" nz-input placeholder="Project Description" name="first"></textarea>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control>
            <nz-form-label class="text-[15px] font-semibold text-dark dark:text-white/[.87] capitalize mb-[10px]">Project privacy:</nz-form-label>
              <div class="flex items-center gap-x-[40px] gap-y-[15px]">
                <label class="text-[15px] capitalize font-normal text-light dark:text-white/60" nz-checkbox name="first" nzValue="private" [ngModel]="true">private</label>
                <label class="text-[15px] capitalize font-normal text-light dark:text-white/60" nz-checkbox nzValue="team">team</label>
                <label class="text-[15px] capitalize font-normal text-light dark:text-white/60" nz-checkbox nzValue="public">public</label>
              </div>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control>
            <nz-form-label class="text-[15px] font-semibold text-dark dark:text-white/[.87] capitalize mb-[10px]">Project Members:</nz-form-label>
            <nz-select class="min-w-[260px] capitalize [&>nz-select-top-control]:border-normal dark:[&>nz-select-top-control]:border-white/10 [&>nz-select-top-control]:bg-white [&>nz-select-top-control]:dark:bg-white/10 [&>nz-select-top-control]:shadow-none [&>nz-select-top-control]:text-dark [&>nz-select-top-control]:dark:text-white/60 [&>nz-select-top-control]:h-[50px] [&>nz-select-top-control]:flex [&>nz-select-top-control]:items-center [&>nz-select-top-control]:rounded-[5px] [&>nz-select-top-control]:px-[20px] [&>.ant-select-arrow]:text-theme-gray dark:[&>.ant-select-arrow]:text-white/60 " nzMode="multiple" nzShowSearch nzAllowClear nzPlaceHolder="Select Member" name="first">
              <nz-option class="flex items-center gap-[10px]" nzCustomContent nzLabel="Erin Gonzales"
                nzValue="erin gonzales">
                <nz-avatar nzIcon="user" [nzSize]="25" nzSrc="assets/images/sellers/1.png"></nz-avatar>
                <span class="ms-[10px]">Erin Gonzales</span>
              </nz-option>
              <nz-option class="flex items-center gap-[10px]" nzCustomContent nzLabel="Darryl Day"
                nzValue="darryl day">
                <nz-avatar nzIcon="user" [nzSize]="25" nzSrc="assets/images/sellers/2.png"></nz-avatar>
                <span class="ms-[10px]">Darryl Day</span>
              </nz-option>
              <nz-option class="flex items-center gap-[10px]" nzCustomContent nzLabel="Marshall Nichols"
                nzValue="marshall nichols">
                <nz-avatar nzIcon="user" [nzSize]="25" nzSrc="assets/images/sellers/3.png"></nz-avatar>
                <span class="ms-[10px]">Marshall Nichols</span>
              </nz-option>
              <nz-option class="flex items-center gap-[10px]" nzCustomContent nzLabel="Virgil Gonzales"
                nzValue="virgil gonzales">
                <nz-avatar nzIcon="user" [nzSize]="25" nzSrc="assets/images/sellers/4.png"></nz-avatar>
                <span class="ms-[10px]">Virgil Gonzales</span>
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <div nz-row nzGutter="25">
          <div nz-col nzMd="12">
            <nz-form-item>
              <nz-form-label class="text-[15px] font-semibold text-dark dark:text-white/[.87] capitalize mb-[10px]">Start Date</nz-form-label>
              <nz-form-control>
                <nz-date-picker
                class="w-full h-[50px] border-normal dark:border-white/10 px-[20px] placeholder-shown:text-light-extra dark:placeholder-shown:text-white/60 rounded-[5px] dark:bg-white/10"
                  [nzDisabledDate]="disabledStartDate"
                  nzShowTime
                  nzFormat="yyyy-MM-dd HH:mm:ss"
                  [(ngModel)]="startValue"
                  nzPlaceHolder="Start"
                  [ngModelOptions]="{standalone: true}"
                  (nzOnOpenChange)="handleStartOpenChange($event)"
                ></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzMd="12">
            <nz-form-item>
              <nz-form-label class="text-[15px] font-semibold text-dark dark:text-white/[.87] capitalize mb-[10px]">End Date</nz-form-label>
              <nz-form-control>
                <nz-date-picker
                class="w-full h-[50px] border-normal dark:border-white/10 px-[20px] placeholder-shown:text-light-extra dark:placeholder-shown:text-white/60 rounded-[5px] dark:bg-white/10"
                  #endDatePicker
                  [nzDisabledDate]="disabledEndDate"
                  nzShowTime
                  nzFormat="yyyy-MM-dd HH:mm:ss"
                  [(ngModel)]="endValue"
                  nzPlaceHolder="End"
                  [ngModelOptions]="{standalone: true}"
                  (nzOnOpenChange)="handleEndOpenChange($event)"
                ></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </form>
    </ng-template>
    <!-- :End New project added -->
  </div>
 </div>
 <div nz-row nzGutter="25" class="mt-[4px]" nzJustify="center">
   <div nz-col nzMd="12" class="mb-[25px]">
     <ng-container *ngIf="showContent; else loadingSkeletonheading">
       <div class="flex items-center flex-wrap gap-[20px] max-md:justify-center">
        <ul nz-menu class="flex flex-wrap items-center mb-0 py-[9px] border-none bg-white dark:bg-white/10 rounded-[5px] [&]:after:hidden [&]:before:hidden">
          <li class="ltr:border-r rtl:border-l dark:border-white/10 last:border-none text-light text-[15px] dark:text-white/[.87] m-0 [&.ant-menu-item-selected]:text-primary font-normal bg-transparent h-[24px] flex items-center justify-center" nz-menu-item [nzSelected]="selectedSort === 'all'" (click)="sortProjects('all')">
            All
          </li>
          <li class="ltr:border-r rtl:border-l dark:border-white/10 last:border-none text-light text-[15px] dark:text-white/[.87] m-0 [&.ant-menu-item-selected]:text-primary font-normal bg-transparent h-[24px] flex items-center justify-center" nz-menu-item [nzSelected]="selectedSort === 'progress'" (click)="sortProjects('progress')">
            In Progress
          </li>
          <li class="ltr:border-r rtl:border-l dark:border-white/10 last:border-none text-light text-[15px] dark:text-white/[.87] m-0 [&.ant-menu-item-selected]:text-primary font-normal bg-transparent h-[24px] flex items-center justify-center" nz-menu-item [nzSelected]="selectedSort === 'completed'" (click)="sortProjects('completed')">
            Complete
          </li>
          <li class="ltr:border-r rtl:border-l dark:border-white/10 last:border-none text-light text-[15px] dark:text-white/[.87] m-0 [&.ant-menu-item-selected]:text-primary font-normal bg-transparent h-[24px] flex items-center justify-center" nz-menu-item [nzSelected]="selectedSort === 'late'" (click)="sortProjects('late')">
            Late
          </li>
          <li class="ltr:border-r rtl:border-l dark:border-white/10 last:border-none text-light text-[15px] dark:text-white/[.87] m-0 [&.ant-menu-item-selected]:text-primary font-normal bg-transparent h-[24px] flex items-center justify-center" nz-menu-item [nzSelected]="selectedSort === 'early'" (click)="sortProjects('early')">
            Early
          </li>
        </ul>
         <!-- Search Box -->
         <div class="3xl:w-[350px] max-ssm:w-full [&>div>div.ant-select-selector]:border-0">
           <nz-input-group class="bg-white dark:bg-white/10 rounded-[20px] h-[38px] flex items-center px-[20px]">
             <input class="bg-transparent border-none text-[15px] shadow-none text-dark dark:text-white/[.87] flex items-center" type="text" nz-input
               placeholder="Search Projects" [(ngModel)]="searchQuery" (ngModelChange)="filterProjects()">
             <i class="text-theme-gray dark:text-white/[.87]" nz-icon nzType="search"></i>
           </nz-input-group>
         </div>
         <!-- :End Search Box -->
       </div>
     </ng-container>
   </div>
   <div nz-col nzMd="12" class="mb-[25px]">
     <ng-container *ngIf="showContent; else loadingSkeletonheading">
        <div class="flex items-center justify-end max-sm:justify-center gap-[20px] flex-wrap">
          <div class="flex flex-wrap items-center gap-[20px] max-sm:justify-center">
            <span class="text-body dark:text-white/60">Sort By:</span>
            <nz-select class="min-w-[260px] capitalize [&>nz-select-top-control]:border-none [&>nz-select-top-control]:bg-white [&>nz-select-top-control]:dark:bg-white/10 [&>nz-select-top-control]:shadow-none [&>nz-select-top-control]:text-dark [&>nz-select-top-control]:dark:text-white/60 [&>nz-select-top-control]:h-[40px] [&>nz-select-top-control]:flex [&>nz-select-top-control]:items-center [&>nz-select-top-control]:rounded-[4px] [&>nz-select-top-control]:px-[20px]" ngModel="category">
              <nz-option nzValue="category" nzLabel="project category"></nz-option>
              <nz-option nzValue="rated" nzLabel="top rated"></nz-option>
              <nz-option nzValue="popular" nzLabel="popular"></nz-option>
              <nz-option nzValue="newest" nzLabel="newest"></nz-option>
              <nz-option nzValue="price" nzLabel="price"></nz-option>
            </nz-select>
          </div>
           <!-- View Mode -->
           <nz-radio-group class="flex items-center gap-[10px] text-theme-gray" [(ngModel)]="view">
            <label class="capitalize w-[40px] h-[40px] rounded-full border-none flex items-center justify-center [&:before]:hidden [&>span]:flex [&>span]:items-center [&>span]:justify-center shadow-none dark:bg-white/10 text-theme-gray dark:text-white/60 [&.ant-radio-button-wrapper-checked]:text-primary dark:[&.ant-radio-button-wrapper-checked]:text-white/[.87]" nz-radio-button nzValue="cardView" nzTooltipTitle="Card View"
              nzTooltipPlacement="bottom" nz-tooltip>
              <i class="text-[15px]" nz-icon nzType="appstore" theme="outline"></i>
            </label>
            <label class="capitalize w-[40px] h-[40px] rounded-full border-none flex items-center justify-center [&:before]:hidden [&>span]:flex [&>span]:items-center [&>span]:justify-center shadow-none dark:bg-white/10 text-theme-gray dark:text-white/60 [&.ant-radio-button-wrapper-checked]:text-primary dark:[&.ant-radio-button-wrapper-checked]:text-white/[.87]" nz-radio-button nzValue="listView" nzTooltipTitle="List View"
              nzTooltipPlacement="bottom" nz-tooltip>
              <i class="text-[15px]" nz-icon nzType="ordered-list" theme="outline"></i>
            </label>
          </nz-radio-group>
          <!-- :End View Mode -->
        </div>
     </ng-container>
   </div>
 </div>
 <div class="container-fluid">
   <div nz-row nzGutter="25" *ngIf="view == 'cardView'">
    <div nz-col nzXl="8" nzMd="12" nzXs="24" class="mb-[25px]" *ngFor="let item of filteredProjects">
      <ng-container *ngIf="showContentShorting; else loadingSkeleton">
        <div class="bg-white dark:bg-white/10 rounded-[10px]">
          <div class="pt-[30px] px-[30px]">
            <div class="flex items-start justify-between">
              <h1 class="flex flex-wrap items-center -m-0.5 text-base">
                <a class="m-0.5 ltr:mr-[11px] rtl:ml-[11px] text-dark dark:text-white/[87] text-15 font-medium capitalize"
                  [routerLink]="['/apps/projects/project-details']">{{item.project}}</a>
                <span class="uppercase text-[10px]">
                  <nz-tag class="mb-0 rounded-[3px] font-bold text-white text-[10px] bg-warning border-warning"
                    *ngIf="item.status == 'progress'" nzTooltip="In Progress">{{item.status}}</nz-tag>
                  <nz-tag class="mb-0 rounded-[3px] font-bold text-white text-[10px] bg-success border-success"
                    *ngIf="item.status == 'completed'" nzTooltip="Completed">{{item.status}}</nz-tag>
                  <nz-tag class="mb-0 rounded-[3px] font-bold text-white text-[10px] bg-primary border-primary"
                    *ngIf="item.status == 'early'" nzTooltip="Early">{{item.status}}</nz-tag>
                  <nz-tag class="mb-0 rounded-[3px] font-bold text-white text-[10px] bg-danger border-danger"
                    *ngIf="item.status == 'late'" nzTooltip="Late">{{item.status}}</nz-tag>
                </span>
              </h1>
              <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu">
                <svg-icon
                  class="text-light dark:text-white/60 dark:group-hover:text-white/[.87] w-[24px] h-[24px] [&>svg]:w-[24px] [&>svg]:h-[24px]"
                  src="assets/images/svg/feather/more-horizontal.svg"></svg-icon>
              </a>
              <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul
                  class="block bg-white dark:bg-[#1b1e2b] shadow-regular dark:shadow-[0_5px_30px_rgba(1,4,19,.60)] rounded-4 capitalize"
                  nzSelectable>
                  <li
                    class="flex items-center text-theme-gray dark:text-white/60 hover:bg-primary/10 hover:text-primary dark:hover:bg-white/10 px-3 py-1.5 text-sm dark:hover:text-white/[.87] gap-[6px]"
                    >
                    view
                  </li>
                  <li
                    class="flex items-center text-theme-gray dark:text-white/60 hover:bg-primary/10 hover:text-primary dark:hover:bg-white/10 px-3 py-1.5 text-sm dark:hover:text-white/[.87] gap-[6px]"
                    >
                    edit
                  </li>
                  <li
                    class="flex items-center text-theme-gray dark:text-white/60 hover:bg-primary/10 hover:text-primary dark:hover:bg-white/10 px-3 py-1.5 text-sm dark:hover:text-white/[.87] gap-[6px]"
                    >
                    leave
                  </li>
                  <li
                    class="flex items-center text-theme-gray dark:text-white/60 hover:bg-primary/10 hover:text-primary dark:hover:bg-white/10 px-3 py-1.5 text-sm dark:hover:text-white/[.87] gap-[6px]"
                    >
                    delete
                  </li>
                </ul>
              </nz-dropdown-menu>
            </div>
            <p class="text-body dark:text-white/60 mt-[15px] mb-[25px]">{{item.desc}}</p>
            <div class="flex items-center mb-[15px] gap-x-[30px]">
              <div class="flex flex-col">
                <span class="text-xs mb-0.5 text-light-extra dark:text-white/60">Start Date</span>
                <strong class="font-medium text-body dark:text-white/60">{{item.startDate}}</strong>
              </div>
              <div class="flex flex-col">
                <span class="text-xs mb-0.5 text-light-extra dark:text-white/60">Deadline</span>
                <strong class="font-medium text-body dark:text-white/60">{{item.endDate}}</strong>
              </div>
            </div>
            <nz-progress class="project-progress" *ngIf="item.status !== 'late'" [nzPercent]="item.progress"
              nzStatus=" {{item.status}}">
            </nz-progress>
            <nz-progress class="project-progress" *ngIf="item.status == 'late'" [nzPercent]="item.progress"
              nzStatus=" {{item.status}}">
            </nz-progress>
            <p class="mt-0.5 text-light-extra dark:text-white/60 text-xs">12/{{item.tasks}} Task Completed</p>
          </div>
          <div class="pt-4 px-[30px] pb-[25px] mt-[17px] border-t border-regular dark:border-white/10">
            <p class="mb-4 text-sm text-light-extra dark:text-white/60">Assigned To</p>
            <div class="flex flex-wrap items-center gap-[6px] capitalize">
              <a routerLinkActive="router-link-active" class="w-[35px] min-w-[35px] h-[35px] rounded-full object-cover"
                *ngFor="let member of (item.member ? item.member.slice(0,2): [])">
                <nz-avatar [nzSrc]="member.avatar" nz-tooltip [nzTooltipTitle]="member.name"></nz-avatar>
              </a>
              <a *ngIf="item.member.length > 2">
                <nz-avatar
                  class="text-dark bg-regularBG dark:bg-white/10 dark:text-white/[.87] font-medium text-[12px] border-[#e4e4e4] dark:border-white/10"
                  [nzText]="'+' + [item.member.length - 2].toString()" nz-tooltip
                  [nzTooltipTitle]="[item.member.length - 2].toString() + ' More'"></nz-avatar>
              </a>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

   </div>
   <div *ngIf="view == 'listView'">
    <div class="bg-white border-none dark:bg-white/10 p-[30px] rounded-xl mb-[30px] overflow-x-auto">
      <nz-table #listViewTable [nzData]="projectList" [nzFrontPagination]="false">
        <thead>
          <tr class="whitespace-nowrap">
            <th
              class="bg-regularBG dark:bg-[#323440] px-[20px] py-[16px] text-start text-light dark:text-white/[.87] text-15px font-medium border-none before:hidden rounded-s-[10px]">
              Project</th>
            <th
              class="bg-regularBG dark:bg-[#323440] px-4 py-[16px] text-start text-light dark:text-white/[.87] text-15px font-medium border-none before:hidden">
              Start Date</th>
            <th
              class="bg-regularBG dark:bg-[#323440] px-4 py-[16px] text-start text-light dark:text-white/[.87] text-15px font-medium border-none before:hidden">
              Deadline</th>
            <th
              class="bg-regularBG dark:bg-[#323440] px-4 py-[16px] text-start text-light dark:text-white/[.87] text-15px font-medium border-none before:hidden">
              Assigned To</th>
            <th
              class="bg-regularBG dark:bg-[#323440] px-4 py-[16px] text-start text-light dark:text-white/[.87] text-15px font-medium border-none before:hidden">
              Status</th>
            <th
              class="text-center bg-regularBG dark:bg-[#323440] px-4 py-[16px] text-light dark:text-white/[.87] text-15px font-medium border-none before:hidden">
              Completion</th>
            <th
              class="bg-regularBG dark:bg-[#323440] px-[20px] py-[16px] text-end text-light dark:text-white/[.87] text-15px font-medium border-none before:hidden rounded-e-[10px] ">
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="group" *ngFor="let item of listViewTable.data">
            <td
              class="pe-4 py-[15px] text-start last:text-end text-dark dark:text-white/[.87] group-hover:bg-transparent text-15 font-medium border-b border-regular dark:border-white/10 before:hidden ">
              <div class="media align-items-center">
                <div>
                  <h5 class="font-medium capitalize text-dark dark:text-white/[.87] text-15">{{item.project}}</h5>
                  <p class="mb-0 text-xs font-normal capitalize text-light-extra dark:text-white/60">{{item.tagLine}}</p>
                </div>
              </div>
            </td>
            <td
              class="px-4 py-[15px] font-normal last:text-end capitalize text-[14px] text-dark dark:text-white/[.87] border-b border-regular dark:border-white/10 group-hover:bg-transparent">
              {{item.startDate}}</td>
            <td
              class="px-4 py-[15px] font-normal last:text-end capitalize text-[14px] text-dark dark:text-white/[.87] border-b border-regular dark:border-white/10 group-hover:bg-transparent">
              {{item.endDate}}</td>
            <td
              class="px-4 py-[15px] font-normal last:text-end capitalize text-[14px] text-dark dark:text-white/[.87] border-b border-regular dark:border-white/10 group-hover:bg-transparent">
              <div class="flex items-cnter gap-[6px]">
                <a routerLinkActive="router-link-active" *ngFor="let item of (item.member ? item.member.slice(0,2): [])">
                  <nz-avatar class="capitalize w-[34px] h-[34px]" nzSize="small" [nzSrc]="item.avatar" nz-tooltip
                    [nzTooltipTitle]="item.name"></nz-avatar>
                </a>
                <a *ngIf="item.member.length > 2">
                  <nz-avatar
                    class="text-dark bg-regularBG dark:bg-white/10 dark:text-white/[.87] font-medium text-[12px] border-[#e4e4e4] dark:border-white/10 capitalize"
                    nzSize="small w-[34px] h-[34px]" [nzText]="'+' + [item.member.length - 2].toString()" nz-tooltip
                    [nzTooltipTitle]="[item.member.length - 2].toString() + ' More'"></nz-avatar>
                </a>
              </div>
            </td>
            <td
              class="px-4 py-[15px] font-normal last:text-end capitalize text-[14px] text-dark dark:text-white/[.87] border-b border-regular dark:border-white/10 group-hover:bg-transparent">
              <span class="uppercase text-[10px]">
                <nz-tag class="mb-0 rounded-[3px] font-bold text-white text-[10px] bg-warning border-warning"
                  *ngIf="item.status == 'in progress'">{{item.status}}</nz-tag>
                <nz-tag class="mb-0 rounded-[3px] font-bold text-white text-[10px] bg-success border-success"
                  *ngIf="item.status == 'completed'">{{item.status}}</nz-tag>
                <nz-tag class="mb-0 rounded-[3px] font-bold text-white text-[10px] bg-primary border-primary"
                  *ngIf="item.status == 'early'">{{item.status}}</nz-tag>
                <nz-tag class="mb-0 rounded-[3px] font-bold text-white text-[10px] bg-danger border-danger"
                  *ngIf="item.status == 'late'">{{item.status}}</nz-tag>
              </span>
            </td>
            <td
              class="px-4 py-[15px] font-normal last:text-end capitalize text-[14px] text-dark dark:text-white/[.87] border-b border-regular dark:border-white/10 group-hover:bg-transparent">
              <nz-progress *ngIf="item.status !== 'Behind'" [nzPercent]="item.progress"
                nzStatus="active {{item.status}}">
              </nz-progress>
              <nz-progress *ngIf="item.status == 'Behind'" [nzPercent]="item.progress" nzStatus="active {{item.status}}">
              </nz-progress>
            </td>
            <td
              class="text-right ps-4 pe-4 py-[15px] font-normal last:text-end capitalize text-[14px] text-dark dark:text-white/[.87] border-b border-regular dark:border-white/10 group-hover:bg-transparent">
              <div>
                <a class="text-gray font-size-18" nz-dropdown nzPlacement="bottomRight" nzTrigger="click"
                  [nzDropdownMenu]="projectListSetting2">
                  <i nz-icon nzType="ellipsis" theme="outline"></i>
                </a>
                <nz-dropdown-menu #projectListSetting2="nzDropdownMenu">
                  <ul
                    class="block bg-white dark:bg-[#1b1e2b] shadow-regular dark:shadow-[0_5px_30px_rgba(1,4,19,.60)] rounded-4 capitalize"
                    nzSelectable>
                    <li
                      class="flex items-center text-theme-gray dark:text-white/60 hover:bg-primary/10 hover:text-primary dark:hover:bg-white/10 px-3 py-1.5 text-sm dark:hover:text-white/[.87] gap-[6px]"
                      nz-menu-item [routerLink]="['/apps/projects/project-details']">
                      <i nz-icon nzType="eye" theme="outline"></i>
                      <span class="m-l-10">View</span>
                    </li>
                    <li
                      class="flex items-center text-theme-gray dark:text-white/60 hover:bg-primary/10 hover:text-primary dark:hover:bg-white/10 px-3 py-1.5 text-sm dark:hover:text-white/[.87] gap-[6px]"
                      >
                      <i nz-icon nzType="edit" theme="outline"></i>
                      <span class="m-l-10">Edit</span>
                    </li>
                    <li
                      class="flex items-center text-theme-gray dark:text-white/60 hover:bg-primary/10 hover:text-primary dark:hover:bg-white/10 px-3 py-1.5 text-sm dark:hover:text-white/[.87] gap-[6px]"
                      >
                      <i nz-icon nzType="delete" theme="outline"></i>
                      <span class="m-l-10">Delete</span>
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
     <div class="mb-[30px]">
      <nz-pagination [nzPageIndex]="3" [nzTotal]="500" nzShowSizeChanger [nzPageSize]="10"></nz-pagination>
     </div>
   </div>
 </div>
